import styled from 'styled-components';

export const Title = styled.h1`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 0 10px;
  color: rgba(0, 0, 0, 0.85);
`;

export const ContLegend = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Legend = styled.div`
  display: flex;
  .concluido {
    display: flex;
    align-items: center;
    margin: 0 10px;

    div {
      width: 10px;
      height: 10px;
      background-color: #fad337;
      margin-right: 5px;
      border-radius: 2px;
    }
  }

  .pendente {
    display: flex;
    align-items: center;
    margin: 0 10px;

    div {
      width: 10px;
      height: 10px;
      background-color: #7fd8ab;
      margin-right: 5px;
      border-radius: 2px;
    }
  }
`;
